// -------------------------------------------//
//              Directive Favorite
// -------------------------------------------//
// Little Star close to a datapoint

angular.module('app.directives.dateTimeInput', []).//

directive('dateTimeInput', ['$document', '$parse', '$q', 'dateTimePickerModal',
    function ($document, $parse, $q, dateTimePickerModal) {
        var obj = {
            scope: {
                // new
                model: '=model',
                // Show Buttons (Savebuttons)
                withButtons: '=withButtons',
                // CallBack when saved
                kCallback: '=kCallback',
                // CallBack when saved
                kCallbackParams: '=kCallbackParams',
                // Suppress Apply on Write model
                supressApply : '=supressApply'
            },
            template: '<p class="g-u-1 overflow-ellipsis">{{displayDate}}</p><span  ng-click="clearDate($event);" class="filter-clear  small-width red obj-icon ng-scope red pointer border-left icon-loeschen-abbrechen" ng-if="withFilterDateClearButton"></span><span ng-click="pickDate();" style="position:absolute;cursor:pointer;" class="obj-icon icon-kalender"></span>',

            link: function (scope,element,i,ctrl) {
                var formatString = 'dd L LTS';
                scope.$watch('model',function(value){
                    if(!value || scope.interact ){ return; };
                    scope.displayDate = moment.utc(value).format(formatString);
                })



                scope.pickDate = function () {
                    var d;
                    if (scope.model) {
                        d = moment.utc(scope.model);
                    } else {
                        d = moment.utc();
                    }
                    scope.displayDate = d.format(formatString);
                    var options = {
                        hideTime: false

                    };
                    dateTimePickerModal(d, options).then(function (modal) {

                        modal.close.then(function (data) {
                            if (data !== undefined) {
                                scope.interact = true;
                                scope.displayDate = moment.utc(data).format(formatString);
                                scope.value = moment.utc(data).format();

                                scope.writeToModel ( );
                            }
                        });
                    });
                };


                scope.writeToModel = function () {

                    if (typeof scope.kCallback == 'function') {
                        var defer = $q.defer();
                        var back = scope.kCallback({
                            promise: defer,
                            params: scope.kCallbackParams,
                            value: scope.value,
                            withButtons: scope.withButtons
                        });
                        // Write to Model if return value == true;
                        defer.promise.then(function(aktVal){
                            // scope.model = scope.value;
                            scope.interact = false;
                            scope.model = aktVal;
                            // We need to render by new model, because scope.model $watch does not fire in fact of scope.interact is true
                            // This is important if we change by Slider and datapoint directive shows buttons for save and clear
                            // While Buttons were shown no new data (e.g. interval) were parsed.
                            scope.value = scope.model;


                        },function(){

                        })
                    } else {
                        // Nothing to check;
                        scope.model = scope.value;
                        scope.interact = false;
                        // Careful using this.
                        // Without a callback (Scenes SetDatapoint) we can run into performance issues
                        // But we need this because Parent Object needs dirtyCheck cycle to display current value
                        // Todo: In future use pherhaps implement a scope.supressApply to handle this
                        if(scope.supressApply){ return };
                        scope.$apply();
                    }

                }

            }
        };
        return obj;
    }]);
